import type {WebflowCssProperties} from '@packages/systems/core/utils/WebflowCssSubset';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {createRgbaColor} from '@packages/systems/core/utils/ColorUtils';

export const buttonStyle: WebflowCssProperties = {
  backgroundColor: createRgbaColor('3898EC'), // from bootflow
  borderBottomLeftRadius: px(0),
  borderBottomRightRadius: px(0),
  borderTopLeftRadius: px(0),
  borderTopRightRadius: px(0),
  borderBottomWidth: px(0),
  borderLeftWidth: px(0),
  borderRightWidth: px(0),
  borderTopWidth: px(0),
  color: createRgbaColor('white'),
  cursor: 'pointer',
  paddingTop: px(9),
  paddingBottom: px(9),
  paddingLeft: px(15),
  paddingRight: px(15),
  textDecoration: 'none',
  display: 'block',
  alignItems: 'center',

  // Override default button styling in Safari et al
  appearance: 'none',
};

export const minimalButtonStyle: WebflowCssProperties = {
  color: createRgbaColor('3898EC'), // from bootflow
  backgroundColor: createRgbaColor('00000000'),
  cursor: 'pointer',
  paddingTop: px(0),
  paddingBottom: px(0),
  paddingLeft: px(0),
  paddingRight: px(0),

  // Override default button styling in Safari et al
  appearance: 'none',
};
